<script>
import Sortable from 'sortablejs'
import { columnMap } from '../data.json'

export default {
  name: 'ColSettingTable',
  data() {
    return {
      dialogTitle: '列完整设置',
      drawer: false,
      direction: 'rtl',
      formData: {},
      currRowIndex: 0,
      inputVisible: false,
      inputValue: ''
    }
  },
  props: {
    tableData: {
      type: Array
    },
    platform: {
      type: Object
    }
  },
  methods: {
    handleRemove(row) {
      const pIndex = this.tableData.findIndex(value => value.prop === row.prop)
      this.tableData.splice(pIndex, 1)
      // this.$emit('handleRemove', row)
    },
    handleReset() {
      this.tableData = columnMap[this.platform.code]
    },
    handleAdd() {
      const count = this.tableData.length
      this.tableData.push({
        'hide': false,
        'prop': `f_${count + 1}`,
        'label': '',
        'width': 120,
        'sortable': false,
        'fixed': false,
        'placeholder': '请输入'
      })

      // 等待DOM更新后滚动到底部
      this.$nextTick(() => {
        // 这种方法适用于 Element UI 2.x 版本
        //使用 this.$refs.table.bodyWrapper 获取表格的滚动容器
        // console.log(this.$refs[`refTableSetting`])
        if (this.$refs[`refTableSetting`]) {
          const tableWrapper = this.$refs[`refTableSetting`].bodyWrapper
          // 在数据更新后，使用 scrollTop 属性设置滚动位置
          tableWrapper.scrollTop = tableWrapper.scrollHeight
        }

      })
    },
    initSortable() {
      const el = this.$el.querySelector('.el-table__body-wrapper tbody')
      Sortable.create(el, {
        animation: 150,
        ghostClass: 'sortable-ghost',
        onEnd: ({ oldIndex, newIndex }) => {
          const currRow = this.tableData.splice(oldIndex, 1)[0]
          this.tableData.splice(newIndex, 0, currRow)
        }
      })
    },
    // handleRowClick(row) {
    //   console.log('当前行数据:', row)
    // },
    handleSet(row, $index) {
      this.formData = row
      this.currRowIndex = $index
      // alert('选项' + JSON.stringify(row))
      this.handleOpenDrawer()
    },
    handleOpenDrawer() {
      this.drawer = true
    },

    handleClose(tag) {
      const pIndex = this.formData.data_range.indexOf(tag)
      if (pIndex > -1) {
        this.formData.data_range.splice(pIndex, 1)
        this.tableData[this.currRowIndex] = this.formData
      }
    },

    showInput() {
      this.inputVisible = true
      // eslint-disable-next-line no-unused-vars
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      const inputValue = this.inputValue
      if (inputValue) {
        if (!this.formData.data_range) {
          this.formData.data_range = []
        }
        this.formData.data_range.push(inputValue)
        this.tableData[this.currRowIndex] = this.formData
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  },
  mounted() {
    this.initSortable()
  }
}
</script>

<template>
  <div>
    <el-table ref='refTableSetting' :data='tableData' height='600' draggable='true' row-key='prop'
              border>
      <el-table-column width='80' label='拖拽' align='center'>
        <template><span class='el-icon-rank'></span></template>
      </el-table-column>
      <el-table-column label='序号' type='index' width='80' align='center'>
      </el-table-column>
      <el-table-column label='显示' prop='hide' width='90' align='center'>
        <template slot-scope='{row}'>
          <el-switch v-model='row.hide' :active-value='false' :inactive-value='true'></el-switch>
        </template>
      </el-table-column>
      <el-table-column label='标识符' prop='prop' width='140' align='center'>
        <template slot-scope='{row}'>
          <el-input v-model='row.prop' placeholder='标识符，唯一' clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column label='名称' prop='label' width='180' align='center'>
        <template slot-scope='{row}'>
          <el-input v-model='row.label' placeholder='列名称' clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column label='宽度' width='100' align='center'>
        <template slot-scope='{row}'>
          <el-input v-model='row.width' placeholder='auto' clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column label='数据类型' width='160' align='center'>
        <template slot-scope='{row}'>
          <div style='display: flex;flex-direction: row;gap: 2px'>
            <el-select v-model='row.data_type' placeholder='数据类型：文本、选项' style='width: 160px' clearable>
              <el-option value='text' label='文本框'></el-option>
              <el-option value='select' label='下拉框'></el-option>
            </el-select>
            <!--            <el-link icon='el-icon-setting' @click='handleSet(row)'></el-link>-->
          </div>
          <!--        <el-input v-model='row.type' placeholder='数据类型：文本、选项' clearable></el-input>-->
        </template>
      </el-table-column>
      <el-table-column label='操作' width='90' align='center'>
        <template slot-scope='{row,$index}'>
          <el-link icon='el-icon-setting' @click='handleSet(row,$index)'></el-link>

          <el-link type='danger' icon='el-icon-close' @click='handleRemove(row)' style='margin-left: 10px'></el-link>
        </template>
      </el-table-column>
    </el-table>
    <div style='margin-top: 10px'>
      <el-button type='warning' @click='handleAdd' icon='el-icon-plus' size='small' round>追加一行</el-button>
      <!--      <el-button type='danger' @click='handleReset' icon='el-icon-reset' size='medium'>重置为默认</el-button>-->
    </div>

    <el-drawer
      title='设置'
      append-to-body
      :visible.sync='drawer'
      :direction='direction'
    >
      <div class='p-10'>
        <el-form :model='formData' label-position='right' label-width='100px' size='small'>
          <el-form-item label='列名'>
            <el-input v-model='formData.label' placeholder='列名称（比如：红人昵称、粉丝数等）' clearable></el-input>
          </el-form-item>
          <el-form-item label='标识符'>
            <el-input v-model='formData.prop' placeholder='要求唯一' clearable></el-input>
          </el-form-item>
          <el-form-item label='描述'>
            <el-input v-model='formData.placeholder' placeholder='占位符（描述列的用途）'></el-input>
          </el-form-item>
          <el-form-item label='列的宽度'>
            <el-input v-model='formData.width' placeholder='宽度（单位：像素px，≈ Excel宽度*7.2）' clearable>
              <span slot='append'>px</span>
            </el-input>
          </el-form-item>
          <el-form-item label='数据类型'>
            <el-select v-model='formData.data_type' placeholder='数据类型：文本、选项' style='width: 160px' clearable>
              <el-option value='text' label='文本框'></el-option>
              <el-option value='select' label='下拉框'></el-option>
            </el-select>
            <!--            <el-input v-model='formData.data_type' placeholder='宽度（单位：像素px，≈ Excel宽度*7.2）' clearable></el-input>-->
          </el-form-item>
          <el-form-item label='可选范围' v-if='formData.data_type==="select"'>
            <div>
              <el-tag
                :key='tag'
                v-for='tag in formData.data_range'
                closable
                size='medium'
                :disable-transitions='false'
                @close='handleClose(tag)'>
                {{ tag }}
              </el-tag>
              <el-input
                class='input-new-tag'
                v-if='inputVisible'
                v-model='inputValue'
                ref='saveTagInput'
                size='small'
                @keyup.enter.native='handleInputConfirm'
                @blur='handleInputConfirm'
              >
                <div>
                  <el-button icon='el-icon-plus'></el-button>
                </div>
              </el-input>
              <el-button v-else class='button-new-tag' size='small' @click='showInput'>+ New Tag</el-button>
            </div>
          </el-form-item>

        </el-form>

      </div>
    </el-drawer>
  </div>

</template>
<style>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>

<style scoped>
.sortable-ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
